import { addFilter } from "./actions";
import { ADD_FILTER } from "./actionType";

const initialState = {
    text: '',
    all: true,
}
const filterReducer = (state = initialState, action) => {

    switch (action.type) {
        case ADD_FILTER:
            return {
                ...state,
                ...action.payload
            }

        default:
            return state
    }

}
export default filterReducer